
/**
 * Using the data of a cache record as the starting point, this method builds an object that
 * maps from the doc ref paths of each item in one of the data sets to the docData of each item.
 * 
 * @param {Object} cacheData - The cache data object, typically from a cache record.
 * @param {string} dataSetKey - The key of the data set to build the map for.
 * @param {string} docCollection - The name of the Firestore collection for the documents.
 *   NOTE: This is usually the same as the dataSetKey, but can differ in some cases.
 * 
 * @returns {Object} - An object mapping from doc ref paths to docData for the specified data set.
 * 
 * @example
 * const cacheData = {
 *   projects: {
 *     'project1': { name: 'Project 1', status: 'live' },
 *     'project2': { name: 'Project 2', status: 'live' }
 *   }
 * };
 * const refPathMap = buildRefPathMap(cacheData, 'projects', 'projects');
 * // refPathMap will be:
 * // {
 * //   'projects/project1': { name: 'Project 1', status: 'live' },
 * //   'projects/project2': { name: 'Project 2', status: 'live' }
 * // }
 */
export const buildRefPathMap = (cacheData = {}, dataSetKey, docCollection) => {
  const dataSet = cacheData[dataSetKey] || {};

  const refPathMap = Object.fromEntries(
    Object.entries(dataSet).map(([docId, docData]) => [`${docCollection}/${docId}`, docData])
  );
  
  return refPathMap;
};
